import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { MsalGuard } from "@azure/msal-angular";
import { LevelComponent } from "../components";

const routes: Routes = [
  {
    path: "",
    canActivate: [MsalGuard],
    canActivateChild: [MsalGuard],
    children: [
      {
        path: "levels/:levelId",
        component: LevelComponent,
        data: { isFullscreen: true },
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class LevelsRoutingModule {}
